module.exports = __webpack_public_path__ + "static/media/FTM-BNB.021c2266.svg";